import axios from 'axios';
//import config from '@/config';

export default axios.create({
    baseURL: 'https://yfat-health-check-func.azurewebsites.net'
});